import { NextSearchParams } from '@/types/general';
import { HOMEPAGE_VIDEO_SLUG } from '@/app/(home-page)/contants';
import InteractifyModal from './modal';
import InteractifySwiper from './swiper';
import { useInteractifyParams } from '../utils/use-vid-params';
interface Props {
  closeHandler: () => void;
  searchParams?: NextSearchParams;
  fetchNextPage?: () => void;
  slug?: string;
  productSlug?: string;
  isModalOpen?: boolean;
}
const InteractifyVideoModal = ({
  closeHandler,
  searchParams,
  fetchNextPage,
  slug,
  productSlug,
  isModalOpen
}: Props) => {
  const {
    activeInteractifyParam
  } = useInteractifyParams();
  const isOpen = typeof isModalOpen !== 'undefined' ? isModalOpen : !!activeInteractifyParam;
  return <InteractifyModal closeHandler={closeHandler} isOpen={isOpen} data-sentry-element="InteractifyModal" data-sentry-component="InteractifyVideoModal" data-sentry-source-file="index.tsx">
            {isOpen && <InteractifySwiper closeHandler={closeHandler} searchParams={searchParams} fetchNextPage={fetchNextPage} slug={slug} productSlug={productSlug} shouldLoadNextPageInSwiper={slug === HOMEPAGE_VIDEO_SLUG} />}
        </InteractifyModal>;
};
export default InteractifyVideoModal;